import { maskPhone } from "@/common/helpers/mask.helpers";
import { format } from "date-fns";
import { ptBR } from "date-fns/locale";

export const EmployeeSection = ({ employeer }) => {
  return (
    <div className="mb-6 border-b pb-4">
      <h2 className="text-lg font-semibold mb-3">
        Identificação do Colaborador
      </h2>
      <div className="grid grid-cols-2 gap-4">
        <div>
          <p>
            <strong>Nome:</strong> {employeer?.name}
          </p>
          <p>
            <strong>Departamento:</strong> {employeer?.type} -{" "}
            {employeer?.position}
          </p>
        </div>
        <div>
          <p>
            <strong>Telefone (WhatsApp):</strong> {maskPhone(employeer?.phone)}
          </p>
          <p>
            <strong>E-mail:</strong> {employeer?.email}
          </p>
        </div>
      </div>
    </div>
  );
};

export const CompanySection = () => {
  return (
    <div className="mb-6 border-b pb-4">
      <h2 className="text-lg font-semibold mb-3">Identificação da Empresa</h2>
      <div className="grid grid-cols-2 gap-4">
        <div>
          <p>
            <strong>Razão Social:</strong> LOCAVIBE LOCAÇÕES LTDA
          </p>
          <p>
            <strong>CNPJ:</strong> 48.012.048/0001-46
          </p>
        </div>
        <div>
          <p>
            <strong>Endereço:</strong> Av. São Paulo, Quadra 19, Lote 03, Nº
            1651 - Jardim das Esmeraldas, Goiânia - GO, 74830-045
          </p>
        </div>
      </div>
    </div>
  );
};

export const EquipmentSection = ({ equipment, category, obs, serieNumber }) => {
  return (
    <div className="mb-6 border-b pb-4">
      <h2 className="text-lg font-semibold mb-3">Equipamentos Entregues</h2>
      <p className="mb-4">
        Os seguintes equipamentos foram entregues ao colaborador para uso
        exclusivo em atividades relacionadas às suas funções na empresa:
      </p>

      <div className="mb-4">
        <h3 className="font-medium mb-2">Tipo: {category?.toUpperCase()}</h3>
        <div className="ml-4">
          <p>
            <strong>Marca:</strong> {equipment?.brand}
          </p>
          <p>
            <strong>Modelo:</strong> {equipment?.name}
          </p>
          <p>
            <strong>Série:</strong>
            {serieNumber}
          </p>
          <p>
            <strong>Observações:</strong> {obs}
          </p>
        </div>
      </div>
    </div>
  );
};

export const TermsSection = () => {
  return (
    <div className="mb-6">
      <h2 className="text-lg font-semibold mb-3 border-b pb-1">
        Termos e Condições de Uso
      </h2>
      <p className="mb-4 ml-4">
        Ao assinar este termo, o colaborador declara estar ciente e de acordo
        com as seguintes condições:
      </p>

      <ol className="list-decimal pl-8 space-y-3">
        <li>
          <strong>Uso Adequado:</strong> O equipamento deve ser utilizado
          exclusivamente para fins profissionais, sendo proibido seu uso para
          atividades pessoais ou não autorizadas pela empresa.
        </li>
        <li>
          <strong>Manutenção e Conservação:</strong> O colaborador deve zelar
          pela integridade do equipamento, garantindo sua conservação e
          comunicação imediata de qualquer defeito ou avaria ao setor de
          Tecnologia da Informação (TI).
        </li>
        <li>
          <strong>Instalação de Softwares:</strong> Somente softwares
          licenciados ou autorizados pela empresa podem ser instalados no
          equipamento. A instalação de programas não autorizados pode resultar
          em medidas disciplinares.
        </li>
        <li>
          <strong>Segurança da Informação:</strong> O colaborador deve seguir as
          diretrizes de segurança da informação da empresa, incluindo uso de
          senhas seguras, não compartilhamento de acessos e conformidade com
          políticas internas de proteção de dados.
        </li>
        <li>
          <strong>Responsabilidade em Caso de Danos ou Extravio:</strong>
          <ul className="list-disc pl-6 mt-2 space-y-2">
            <li>
              Se o equipamento sofrer danos por mau uso, negligência,
              imprudência ou for extraviado, o colaborador será responsável pelo
              ressarcimento do valor equivalente ao equipamento da mesma marca
              ou modelo similar de mercado.
            </li>
            <li>
              Em caso de roubo ou furto, o colaborador deve apresentar o boletim
              de ocorrência policial no prazo de 24 horas.
            </li>
          </ul>
        </li>
      </ol>

      <div className="mt-6">
        <h3 className="text-md font-semibold mb-2 border-b pb-1">
          Devolução do Equipamento
        </h3>
        <ul className="list-disc pl-6 space-y-2">
          <li>
            O colaborador se compromete a devolver o equipamento e todos os
            acessórios entregues nas mesmas condições de conservação,
            considerando o uso normal, no prazo máximo de 2 (dois) dias úteis
            após a rescisão contratual ou encerramento do vínculo com a empresa.
          </li>
          <li>
            A devolução será registrada mediante conferência do setor de TI.
          </li>
        </ul>
      </div>

      <div className="mt-6">
        <h3 className="text-md font-semibold mb-2 border-b pb-1">
          Auditoria e Fiscalização
        </h3>
        <p className="ml-4">
          A empresa se reserva o direito de realizar inspeções e auditorias no
          equipamento sem aviso prévio, garantindo a conformidade com as
          políticas internas.
        </p>
      </div>
    </div>
  );
};
export const SignatureSection = () => {
  const today = new Date();
  return (
    <div className="mt-8">
      <div className="mb-8 p-4">
        <h3 className="text-md font-semibold mb-3 text-center">
          Declaração do Colaborador
        </h3>
        <p className="text-justify italic">
          Declaro que recebi o(s) equipamento(s) acima descrito(s) em perfeitas
          condições de uso e que estou ciente das minhas responsabilidades
          conforme disposto neste termo.
        </p>
        <p className="mt-4">
          Local e Data: Goiânia,{" "}
          {format(today, "dd 'de' MMMM 'de' yyyy", { locale: ptBR })}.
        </p>
      </div>
      <div className="grid grid-cols-2 gap-8">
        <div className="text-center">
          <div className="border-t border-black mt-12 pt-2">
            <p>Assinatura do Colaborador</p>
          </div>
        </div>
        <div className="text-center">
          <div className="border-t border-black mt-12 pt-2">
            <p>Assinatura do Representante da Empresa</p>
          </div>
        </div>
      </div>
    </div>
  );
};
